import { type ReactNode } from 'react';

import Background from '@/images/background.jpg';
import Logo from '@/images/logo_felice_headwear.png';

interface BrandedPageProps {
    children?: ReactNode;
}

const BrandedPage = function ({ children }: BrandedPageProps) {

    return (
        <main className='relative min-h-screen flex items-center justify-center p-4 overflow-hidden'>
            {/* Background Image */}
            <div
                className='absolute inset-0 bg-cover bg-center bg-no-repeat'
                style={ { backgroundImage: `url(${ Background })` } }
            >
                {/* Overlay for better readability */}
                <div className='absolute inset-0 bg-background/20 backdrop-blur-[1px]' />
            </div>

            {/* Content */}
            <div className='relative z-10 w-full flex flex-col items-center'>
                {/* Logo */}
                <div className='mb-6 animate-fade-in'>
                    <img
                        alt='Félice Headwear'
                        className='h-20 md:h-24 w-auto object-contain'
                        src={ Logo }
                    />
                </div>

                <div className='glass-card rounded-2xl p-8 md:p-10 w-full sm:w-auto animate-slide-up'>
                    {children}
                </div>

                {/* Footer */}
                <footer className='mt-8 text-center text-xs text-muted-foreground animate-fade-in' style={ { animationDelay: '0.3s' } }>
                    <p>© 2026 Félice Headwear. All rights reserved.</p>
                    <div className='mt-2 space-x-4'>
                        <span className='hover:text-foreground transition-colors'>Privacy Policy</span>
                        <span className='hover:text-foreground transition-colors'>Terms of Service</span>
                        <span className='hover:text-foreground transition-colors'>Contact</span>
                    </div>
                </footer>
            </div>
        </main>
    );
};

export default BrandedPage;
